<div class="attribute-editor-component folder-component-container" rvSpinner="loading-folder" [rvShowSpinner]="processing">
  <div class="attribute-editor-row">
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          @if (!isGooglePhotosAlbum) {
            <div class="flex-row flex-wrap space-between mb-3">
              @if (isDocument) {
                <span>
                  <span id="folder-component-folder-name" title="{{folderPath}}">
                    <strong>{{folderName}}</strong><br>
                    <em>{{values.assetFiles ? values.assetFiles + ' pages' : ''}}</em>
                  </span>
                </span>
              }
              @else {
                <span>
                  {{typeName}} <span id="folder-component-folder-name" title="{{folderPath}}" [shown]="!isGooglePhotosAlbum"> — {{folderName}}</span>
                </span>
              }
              @if (storageManagerService.isCanva(values.source)) {
                <div class="flex-row justify-end w-100 gap-2 mt-2">
                  <streamline-icon aria-hidden="true" name="canva" class="u_lh-1" width="16" height="16" />
                  <a id="folder-edit-with-canva" class="madero-link u_clickable" (click)="editWithCanva()">Edit with Canva</a>
                </div>
              }
              @else {
                <a tabindex="0" id="folder-component-source" class="madero-link u_clickable" (click)="selectMedia()" (keyup.enter)="selectMedia()">Edit</a>
              }
            </div>
          }
          @if (values.fileMissing) {
            <div class="panel tw-mt-[16px]">
              <div class="panel-body bg-warning">
                <i aria-hidden="true" class="fa fa-warning icon-left"></i>
                <span [shown]="values.type === 'storage-file'">
                  This file cannot be displayed properly because it does not exist in storage
                  (it may have been moved, renamed or deleted). Please select a new file.
                </span>
                <span [shown]="values.type === 'storage-folder'">
                  This folder is either empty, or it has been moved, renamed or deleted.
                  Please select a new file or folder.
                </span>
              </div>
            </div>
          }
          @else if (conversionError) {
            <div class="panel mt-4">
              <div class="panel-body bg-warning">
                <i aria-hidden="true" class="fa fa-warning icon-left"></i>
                <span>
                  The file could not be converted for use in the playlist.<br>
                  {{ conversionError }}
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  @if (isGooglePhotosAlbum) {
    <div class="attribute-editor-row">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <div class="has-error">
              <div>
                <p class="help-block mt-1 font-weight-bold">The Google Photos feature is no longer available.</p>
              </div>
          </div>
          </div>
        </div>
      </div>
    </div>
  }
  <div [hidden]="isGooglePhotosAlbum">
    <div class="attribute-editor-row folder-component-list-duration" [hidden]="values.type === 'storage-file' && !isDocument">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label>Show each {{ isDocument ? 'page' : 'image' }} for:</label>
            <div class="input-group">
              <input type="number" id="folder-component-duration" class="form-control" [(ngModel)]="values.duration" (change)="saveDuration()">
              <span class="input-group-addon">Seconds</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="attribute-editor-row" [hidden]="fileType === 'image' || isDocument">
      <div id="folder-component-volume">
        <label>Video Volume:</label>
        <div class="w-100 flex flex-row gap-3">
          <mat-icon svgIcon="volume" class="mr-1 large"></mat-icon>
          <mat-slider
            min="0"
            max="100"
            step="1"
            color="accent"
            aria-label="Video volume control"
            class="flex-grow"
          >
            <input
              matSliderThumb
              [(ngModel)]="values.volume"
              (valueChange)="saveVolume()"
              [attr.aria-valuetext]="values.volume + ' percent volume'"
            />
          </mat-slider>
          <div class="volume">{{ values.volume }}</div>
        </div>
      </div>
    </div>
    <div class="attribute-editor-row" [shown]="isVideo">
      <div class="row pt-3">
        <div class="col-xs-12">
          <div class="flex-row flex-wrap space-between">
            <label>Video Subtitles (.vtt):</label>
            <button [shown]="!values.subtitlesSource" type="button" id="te-add-subtitles" name="te-add-subtitles" class="btn btn-default" (click)="addSubtitles()" mat-stroked-button><mat-icon svgIcon="add" class="medium dark"></mat-icon>Add Subtitles</button>
          </div>
        </div>
      </div>
      <div class="row" [shown]="values.subtitlesSource">
        <div class="col-xs-12">
          <div class="form-group tw-mb-[10px]"> 
            <div class="flex-row flex-wrap space-between">
              <span class="subtitles-filename" title="{{values.subtitlesSource | filename}}">{{values.subtitlesSource | filename}}</span>
              <button
                mat-icon-button
                (click)="deleteSubtitles()"
                aria-label="Delete subtitles"
                class="delete-subtitles mdc-icon-button mat-mdc-icon-button"
              >
              <mat-icon svgIcon="trash"></mat-icon>
            </button>
            </div>
            @if (values.subtitlesFileMissing) {
              <div class="panel tw-mt-[8px]">
                <div class="panel-body bg-warning">
                  <i aria-hidden="true" class="fa fa-warning icon-left"></i>
                  <span>
                    This file cannot be displayed properly because it does not exist in storage
                    (it may have been moved, renamed or deleted). Please select a new file.
                  </span>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </div>
    <div class="attribute-editor-row" [shown]="values.subtitlesSource">
      <div class="flex-row left-right-aligner pt-3">
        <label id="folder-center-subtitles-label" class="mb-0 control-label">Center Subtitles:</label>
        <mat-slide-toggle class="pl-3" [checked]="values.centerSubtitles" (change)="centerSubtitlesChanged($event.checked)" [attr.aria-labelledby]="'folder-center-subtitles-label'"></mat-slide-toggle>
      </div>
    </div>
    <div class="attribute-editor-row" [hidden]="values.type === 'storage-file' && !isDocument">
      <div class="row">
        <div class="col-xs-12">
          <div class="form-group">
            <label class="u_margin-sm-top">Transition between folder items:</label>
            <select id="folder-component-transition" class="form-control" [(ngModel)]="values.transition" (change)="saveTransition()">
              <option value="">No Transition</option>
              <option value="fadeIn">Fade In</option>
              <option value="slideFromLeft">Slide from left</option>
              <option value="slideFromRight">Slide from right</option>
              <option value="slideFromTop">Slide from top</option>
              <option value="slideFromBottom">Slide from bottom</option>
              <option value="zoomIn">Zoom in</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
